import { AxiosRequestConfig } from 'axios';

// Local request metadata only: never included in the body or HTTP headers.
export interface RequestDiagnostics {
    reportingOwner: 'payment';
    operation: string;
    stage: string;
}
export interface DiagnosticRequestConfig extends AxiosRequestConfig {
    requestDiagnostics?: RequestDiagnostics;
    diagnosticStartedAt?: number;
}
const operations = ['initialize-card-entry', 'initialize-saved-card', 'new-subscription', 'replace-card', 'change-plan', 'billing-info', 'load-billing'];
const stages = ['client-init', 'three-ds-init', 'hosted-fields-init', 'tokenize', 'save-card', 'calculate-tax', 'validate-eu-vat', 'get-payment-info', 'verify-balance', 'verify-subscription', 'tax-record', 'create-subscription', 'update-subscription', 'save-billing-info', 'load-billing', 'refresh-billing'];

export function requestDiagnostics(value?: RequestDiagnostics): RequestDiagnostics | undefined {
    if (value?.reportingOwner !== 'payment') return undefined;
    return {
        reportingOwner: 'payment',
        operation: operations.includes(value.operation) ? value.operation : 'unknown',
        stage: stages.includes(value.stage) ? value.stage : 'unknown',
    };
}
